import { actions, Invoice } from 'entities';

import { ExcelButton } from 'components/Buttons';

import { downloadExcel } from './utils';

interface ExcelProps {
  children?: never;
  invoices: Invoice[];
  onSuccess?: () => void;
}

export function DownloadInvoiceExcelButton({ invoices, onSuccess }: ExcelProps) {
  const download = actions.invoice.downloadInvoicesExcel.use({
    params: {
      invoices: invoices.map(({ id }) => id),
    },

    onSuccess: (data) => {
      onSuccess?.();
      downloadExcel(data);
    },
  });

  return <ExcelButton {...download.buttonProps} />;
}
